import { Component } from '@angular/core';
import { SanitizeHtmlPipe } from '../../pipes/sanitize.pipe';
@Component({
  selector: 'dynamic',
  template: ""
})
export class DynamicComponent {
  public data: any = "funcionou essa porra!";
  
}
